const validateForm = ({ formData, individual, customMessage = false }) => {
  const errors = {};

  // Common Validators
  const isEmpty = (value) => !value?.trim();
  const matchRegex = (value, regex) => regex.test(value);
  const getMsg = (field, defaultMsg, fallback = "Invalid " + field) =>
    customMessage ? fallback : defaultMsg;

  // Field-Specific Regex Patterns
  const regex = {
    name: /^[a-zA-Z0-9\s\-()&-',.]{1,40}$/,
    businessName: /^[a-zA-Z0-9\s\-()&-',.]{1,40}$/,
    profileName: /^[a-zA-Z0-9\s\-,']{1,16}$/,
    address: /^[a-zA-Z0-9\s,.\-#'()]{1,100}$/,
    city: /^[a-zA-Z0-9\s\-()&-',.]{1,50}$/,
    zip: /^\d{5}$/,
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    phone: /^\d{10}$/,
  };

  // Shared field validation logic
  const validateField = (
    key,
    label,
    value,
    pattern,
    requiredMsg,
    invalidMsg
  ) => {
    if (value !== undefined) {
      if (isEmpty(value)) {
        errors[key] = getMsg(label, requiredMsg, invalidMsg);
      } else if (pattern && !matchRegex(value, pattern)) {
        errors[key] = invalidMsg;
      }
    }
  };

  const isIndividual =
    individual === "Individual" || individual === "IndividualCobuyer";
  const isBusiness =
    individual === "Business Entity" || individual === "BusinessEntityCobuyer";

  if (isIndividual) {
    validateField(
      "firstName",
      "Name",
      formData.firstName,
      regex.name,
      "First name is required",
      "Invalid Name"
    );
    validateField(
      "profileName",
      "Name",
      formData.profileName,
      regex.profileName,
      "Profile name is required",
      "Invalid Name"
    );
    validateField(
      "lastName",
      "Name",
      formData.lastName,
      regex.name,
      "Last name is required",
      "Invalid Name"
    );
    validateField(
      "emailId",
      "Email",
      formData.emailId,
      regex.email,
      "Email is required",
      "Invalid Email"
    );
    validateField(
      "address1",
      "Individual Address",
      formData.address1,
      regex.address,
      "Address is required",
      "Invalid Individual Address"
    );
    validateField(
      "city",
      "City",
      formData.city,
      regex.city,
      "City is required",
      "Invalid City"
    );
    validateField(
      "zip",
      "Zip Code",
      formData.zip,
      regex.zip,
      "Zip Code is required",
      "Invalid Zip Code"
    );
    validateField(
      "phoneNumber",
      "Phone Number",
      formData.phoneNumber?.replace(/\D/g, ""),
      regex.phone,
      "Phone number is required",
      "Invalid Phone Number"
    );

    if (formData.state !== undefined && !formData.state) {
      errors.state = getMsg(
        "State",
        "State is required",
        "Please select a state"
      );
    }
  }

  if (isBusiness) {
    validateField(
      "firstName",
      "Name",
      formData.firstName,
      regex.businessName,
      "First name is required",
      "Invalid Name"
    );
    validateField(
      "lastName",
      "Name",
      formData.lastName,
      regex.businessName,
      "Last name is required",
      "Invalid Name"
    );

    if (formData.corporationName !== undefined) {
      if (isEmpty(formData.corporationName)) {
        errors.corporationName = getMsg(
          "Corporation Name",
          "Corporation name is required",
          "Invalid Corporation Name"
        );
      } else if (formData.corporationName.length < 2) {
        errors.corporationName = "Invalid Corporation Name";
      }
    }

    validateField(
      "address1",
      "Corporation Address",
      formData.address1,
      regex.address,
      "Address is required",
      "Invalid Corporation Address"
    );
    validateField(
      "city",
      "City",
      formData.city,
      regex.city,
      "City is required",
      "Invalid City"
    );
    validateField(
      "zip",
      "Zip Code",
      formData.zip,
      regex.zip,
      "Zip code is required",
      "Invalid Zip Code"
    );
    validateField(
      "emailId",
      "Email",
      formData.emailId,
      regex.email,
      "Email is required",
      "Invalid Email"
    );
    validateField(
      "phoneNumber",
      "Phone Number",
      formData.phoneNumber?.replace(/\D/g, ""),
      regex.phone,
      "Phone number is required",
      "Invalid Phone Number"
    );

    if (formData.state !== undefined && !formData.state) {
      errors.state = getMsg(
        "State",
        "State is required",
        "Please select a state"
      );
    }
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export default validateForm;
